<template>
  <div class="container min-vh-90">
    <div class="row min-vh-90">
      <div class="col-4 m-auto text-center">
        <CIcon name="cil-lock-locked" size="8xl" />
        <h1>Sin autorización</h1>
        <p>No tienes acceso a esta página. Elige una opción del menú o:</p>
        <button type="button" class="btn btn-primary btn-sm" @click="ok">
          Volver al inicio
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Page_401",
  methods: {
    ok() {
      this.$router.go(-1);
    },
  },
};
</script>
